import React, { FC, useCallback } from 'react';
import { useStaticGlobalIntl } from 'utils/intl/useStaticGlobalIntl';
import { GenderModel, StatusModel } from '@utmost.co/enterprise-models';
import { DataTableRowAction, DataTableRowActions } from '@utmost.co/utmost-design-system';
import { tokens } from '@beeline.com/bp-design-system';

interface Props {
  gender: GenderModel;
  showDeleteModal: (uids: string[]) => void;
  onEditClick: (gender: GenderModel) => void;
  onClickToggleStatus: (uid: string, status: StatusModel) => void;
}

export const GenderActions: FC<React.PropsWithChildren<Props>> = ({
  gender,
  showDeleteModal,
  onEditClick,
  onClickToggleStatus
}) => {
  const canDelete = gender.sourceName === 'UTMOST';
  const isActive = gender.status === 'ACTIVE';
  const [updateLabel, deleteLabel, enableLabel, disableLabel, actionsLabel] = useStaticGlobalIntl(
    'general.Update',
    'general.Delete',
    'general.Enable',
    'general.Disable',
    'table.actions'
  );

  const onDelete = useCallback(() => showDeleteModal([gender.uid]), [gender.uid, showDeleteModal]);

  return (
    <DataTableRowActions actionsLabel={actionsLabel} dataTest="gender-actions">
      <DataTableRowAction onClick={() => onEditClick(gender)} dataTest="overflow__action__edit">
        {updateLabel}
      </DataTableRowAction>
      <DataTableRowAction
        onClick={() => onClickToggleStatus(gender.uid, isActive ? 'INACTIVE' : 'ACTIVE')}
        dataTest="overflow__action__toggle__status"
      >
        {isActive ? disableLabel : enableLabel}
      </DataTableRowAction>
      <DataTableRowAction
        disabled={!canDelete}
        style={{ color: tokens.colorAlert }}
        onClick={onDelete}
        dataTest="overflow__action__delete"
      >
        {deleteLabel}
      </DataTableRowAction>
    </DataTableRowActions>
  );
};
